import { render } from "./tpl-grid.vue?vue&type=template&id=5dab5f9f&scoped=true"
import script from "./tpl-grid.vue?vue&type=script&lang=js"
export * from "./tpl-grid.vue?vue&type=script&lang=js"

import "./tpl-grid.vue?vue&type=style&index=0&id=5dab5f9f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dab5f9f"],['__file',"src/views/dragger/template/tpl-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dab5f9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dab5f9f', __exports__)) {
    console.log('reload')
    api.reload('5dab5f9f', __exports__)
  }
  
  module.hot.accept("./tpl-grid.vue?vue&type=template&id=5dab5f9f&scoped=true", () => {
    console.log('re-render')
    api.rerender('5dab5f9f', render)
  })

}


export default __exports__